import { BookOpen } from 'lucide-react';
import { NavigationList, SidebarLink } from './navigation';
import { NavigationItem } from '../hooks/useNavigation';

interface MainNavigationProps {
  isVisible: boolean;
  navigation: NavigationItem[];
}

export function MainNavigation({ isVisible, navigation }: MainNavigationProps) {
  return (
    <div
      className={`absolute inset-0 pl-3 pr-1 transform transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      <NavigationList items={navigation} isSidebarCollapsed={false} />
      <div className="mb-1">
        <SidebarLink
          href="https://docs.jua.ai"
          icon={BookOpen}
          isSidebarCollapsed={false}
          isExternal
          title="Documentation"
          dataAttribute="nav-docs-external"
        >
          Documentation
        </SidebarLink>
      </div>
    </div>
  );
}
